/* Карточка. Из дизайн-системы «Изнутри»: .card, .card-pad, .card-head. */

.card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  /* Карточка стоит в сетке из трёх колонок; без этого длинное слово внутри
     растягивает колонку и ломает всю сетку разом. */
  min-width: 0;
}

.pad {
  padding: 16px 18px;
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 13px 18px;
  border-bottom: 1px solid var(--border);
  min-width: 0;
}

.title {
  margin: 0;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  min-width: 0;
  text-wrap: pretty;
}

.spacer {
  flex: 1;
}
